import React, { useState, useEffect, useRef } from 'react';
import api from '../../../services/api';
import { toast } from 'sonner';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table';
import { Plus, Trash2, Search, Upload, X } from 'lucide-react';

export function SupplierCategoryAdder({ form, setForm }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const blurRef = useRef(null);

  const doSearch = async (q) => {
    try {
      const res = await api.get('/api/data/categories', { params: { search: q || '', page_size: 10 } });
      setResults(res.data.data || []);
    } catch { setResults([]); }
  };

  const addCategory = (cat) => {
    if ((form.category_codes || []).some(c => c.code === cat.code)) {
      toast.info(`${cat.code} already added`);
      return;
    }
    setForm(p => ({ ...p, category_codes: [...(p.category_codes || []), { code: cat.code, description: cat.description }] }));
    setQuery('');
    setOpen(false);
    toast.success(`Added ${cat.code}`);
  };

  return (
    <div className="flex items-center gap-2 mb-4 relative">
      <div className="relative flex-1 max-w-xs">
        <Input value={query} placeholder="Search category code..."
          onChange={e => { setQuery(e.target.value); doSearch(e.target.value); setOpen(true); }}
          onFocus={() => { doSearch(query || ''); setOpen(true); }}
          onBlur={() => { blurRef.current = setTimeout(() => setOpen(false), 300); }}
          className="h-8 pr-8" />
        <Search className="absolute right-2 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground pointer-events-none" />
        {open && results.length > 0 && (
          <div className="absolute z-[200] top-full left-0 right-0 mt-1 bg-background border rounded-md shadow-lg max-h-48 overflow-y-auto"
            onMouseDown={e => e.preventDefault()}>
            {results.map(cat => (
              <div key={cat.code} className="px-3 py-2 text-sm hover:bg-accent cursor-pointer border-b last:border-b-0"
                onMouseDown={e => { e.preventDefault(); e.stopPropagation(); addCategory(cat); }}>
                <span className="font-mono text-primary text-xs font-medium">{cat.code}</span>
                <span className="text-muted-foreground text-xs ml-2">— {cat.description}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
